
import articleSection from '~/pages/gameInformation/articleSection'
import GoodsListPage from '@/components/GoodsListPage' //分页
export default {
	components: {
		articleSection,
		GoodsListPage
	},
	data() {
		return {
			// 获取选中的导航菜单length
			navigationIndex: 0,
			// 分页
			pageInfo: {
				page: 1,
				pageSize: 10,
				total: 0
			},
			// 咨询类型id
			typeId: 0,
			// 文章列表
			articleList: null,
			// tdk名称
			typeTitle: '',
			typeName: '',
			loading: true,
			whether: 0
		}
	},
	async asyncData({ app, route }) {
		// 文章列表初始化参数
		const par = {
			page: 1,
			pageSize: 10
		}
		const articleTypesListRes = await app.$api.listArticleTypesAPI()
		const articleListRes = await app.$api.informationListAPI(par)
		if (articleTypesListRes.success) {
			articleTypesListRes.data.unshift({
				id: null,
				name: '全部'
			})
		}
		return {
			BAIDU_URL: process.env.BAIDU_URL + route.path,
			BAIDU_DATE: app.$formattedDateTime(),
			BAIDU_PUSH_DATE: articleListRes.data.records.length > 0 ? articleListRes.data.records[0].publishTime + 'T00:00:00' : '',
			articleTypesListRes: articleTypesListRes.data,
			articleListRes: articleListRes.data
		}
	},
	head() {
		return {
			title: '游戏角色强度排行榜_阵容搭配攻略资讯-盼之代售',
			meta: [
				{
					hid: 'description',
					name: 'description',
					content: '盼之代售游戏账号交易平台，为游戏玩家提供网游角色强度排行榜，阵容职业搭配攻略，游戏最新版本新服更新，海内外新手游端封测公测入驻等游戏行业资讯。'
				},
				{
					hid: 'keywords',
					name: 'keywords',
					content: `${this.typeName || '游戏资讯，游戏攻略，盼之代售'}`
				}
			],
			script: [
				{
					hid: 'ldjson-schema',
					innerHTML: `{"@context": "https://ziyuan.baidu.com/contexts/cambrian.jsonid","@id":"https://${this.BAIDU_URL}","pubDate": "${this.BAIDU_PUSH_DATE}","upDate": "${this.BAIDU_DATE}"}`,
					type: 'application/ld+json'
				}
			],
			__dangerouslyDisableSanitizersByTagID: {
				'ldjson-schema': ['innerHTML']
			}
		}
	},
	computed: {
		// 页面名
		title() {
			return this.$route.query.name || '游戏资讯'
		},
		// 文章列表
		articleListData() {
			return this.articleList || this.articleListRes.records
		},
		// 设置head
		headTitle() {
			return function (val, index) {
				if (val == '全部') {
					return index ? '游戏角色强度排行榜_阵容搭配攻略资讯-盼之代售' : '游戏资讯，游戏攻略，盼之代售'
				} else {
					return index ? `${val}角色强度排行榜_阵容搭配攻略资讯-盼之代售` : `${val}资讯，${val}攻略，盼之代售`
				}
			}
		},
		orientation() {
			return function () {
				if (this.whether == 2) {
					return 'isFixed'
				} else if (this.whether == 3) {
					return 'isAbsolute'
				} else {
					return ''
				}
			}
		}
	},
	async mounted() {
		if (!this.articleListRes.records.length) {
			this.loading = false
		}
		// 初始化文章列表分页总数
		this.pageInfo.total = this.articleListRes.total
		// 获取最新文章列表
		await this.$store.dispatch('game/GameLatestArticlesList')
		// 获取热门文章列表
		await this.$store.dispatch('game/GameHotArticlesList')
		// 添加监听滚动
		if (process.browser) {
			window.addEventListener('scroll', this.handleScroll)
		}
	},
	destroyed() {
		// 销毁 EventListener
		window.removeEventListener('scroll', this.handleScroll)
	},
	methods: {
		// 跳转详情
		jumpDetails(val, index) {
			this.$router.push({ path: `/articleDetails/${val.id}` })
		},
		// 点击热门菜单
		hotMenu(val, index) {
			// 不能重复点击
			if (this.navigationIndex == index) return
			// 选中状态
			this.navigationIndex = index
			// 重置分页
			this.pageInfo.page = 1
			// 保存id
			this.typeId = val.id
			// tdk名称
			this.typeTitle = this.headTitle(val.name, 1)
			// tdk keywords
			this.typeName = this.headTitle(val.name, 0)
			// 获取数据
			this.obtainInformationList(val.id)
		},
		// 分页
		handleCurrentChange(page) {
			this.pageInfo.page = page
			this.obtainInformationList(this.typeId)
		},
		// 分页页数变化
		handleSizeChange(pageSize) {
			this.pageInfo.page = 1
			this.pageInfo.pageSize = pageSize
			this.obtainInformationList(this.typeId)
		},
		// 获取文章列表的接口
		obtainInformationList(id = null) {
			const par = {
				page: this.pageInfo.page,
				pageSize: this.pageInfo.pageSize
			}
			// 是否存在咨询标签id
			if (id) {
				par.typeId = Number(id)
			}
			this.$api.informationListAPI(par).then(res => {
				if (res.success) {
					this.pageInfo.total = res.data.total
					this.articleList = res.data.records
					this.loading = false
				}
			})
			// this.$store.dispatch("game/GameArticleList", informationListData)
		},
		// 右侧菜单吸顶效果
		handleScroll() {
			//计算滚动条位置
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
			// 右侧盒子总高度
			let boxHeight = this.$refs.rightBox.offsetHeight
			// 可视高度
			let innerHeight = window.innerHeight
			// 页面总高度
			let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
			// 滚动条距离底部的距离
			let scrollBottom = scrollHeight - innerHeight - scrollTop
			// 是否吸顶
			if (scrollHeight - 439 <= boxHeight) {
				this.whether = 0
			} else if (scrollBottom < 215) {
				this.whether = 3
			} else if (scrollTop > boxHeight - innerHeight + 214) {
				this.whether = 2
			} else {
				this.whether = 0
			}
		}
	},
	created() {
		this.$watch(
			() => this.$route.params,
			() => {
				// 对路由变化做出响应...
				if (Object.keys(this.$route.query).length == 0) {
					this.obtainInformationList()
				}
			}
		)
	}
}
